import { render } from "./payroll-details.vue?vue&type=template&id=456f26f0&scoped=true"
import script from "./payroll-details.vue?vue&type=script&lang=js"
export * from "./payroll-details.vue?vue&type=script&lang=js"

import "./payroll-details.vue?vue&type=style&index=0&id=456f26f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456f26f0"]])

export default __exports__